import {createAction} from 'redux-actions';
import {ARTICLES_SET_VIEW} from '../../action-types';

export const setView = createAction(ARTICLES_SET_VIEW);
